<template>
    <!--srccomponentstimeLineindexvuehtmlStart-->

    <div id="defaultId1" class="    u30e89">
        <div id="g089c4" class="    u41a77">
            <div id="g91aa7" class="    u54fe0">
                <div id="g1a8fb" class="    u2eaef">
                </div>
            </div>
            <div id="g09b0a" class="    u6f3b7">
                <!-- 标题和名称 -->
                <div id="g45c69" class="    uccfc3">
                    <span id="g560a5" class="    u582e0">{{time}}
                    </span>
                    <span id="g6950f" class="    uc86b5">{{ name }}
                    </span>
                </div>
                <!-- 内容 -->
                <div id="g09a51" class="    u8ed36">{{ text }}
                </div>
            </div>
        </div>
    </div>
    <!--srccomponentstimeLineindexvuehtmlEnd-->

</template>
<script>
    // interfaceCode
    //importStart

    //importEnd

    export default {
        name: "",

        props: {
            // srccomponentstimeLineindexvuePropsStart

            // srccomponentstimeLineindexvuePropsEnd

            time: {
                type: String,
                default: ""
            },

            name: {
                type: String,
                default: ""
            },

            text: {
                type: String,
                default: ""
            }
        },

        mounted() {
            // defaultLoad
            // srccomponentstimeLineindexvueMountedStart

            // srccomponentstimeLineindexvueMountedEnd

        },
        components: {},
        data() {
            return {
                // insertData
                // srccomponentstimeLineindexvueDataStart

                // srccomponentstimeLineindexvueDataEnd

            }
        },
        methods: {
            // insertMethod
            // srccomponentstimeLineindexvueMethodStart
            // default
            default () {

            }
            // srccomponentstimeLineindexvueMethodEnd

        },
        computed: {}
    };
</script>
<style>
    .srccomponentstimeLineindexvuecssStart {}

    .u30e89 {
        display: block;
        width: 100%;
    }

    .u41a77 {
        display: flex;
        justify-content: flex-start;
        width: 100%;
        flex-direction: row;
    }

    .u54fe0 {
        width: 1px;
        height: auto;
        background-color: rgb(221, 221, 221);
        margin-left: 0.04em;
    }

    .u2eaef {
        width: 0.71em;
        height: 0.71em;
        background-color: rgb(18, 144, 201);
        border-bottom-left-radius: 100em;
        border-top-left-radius: 100em;
        border-top-right-radius: 100em;
        border-bottom-right-radius: 100em;
        margin-left: -0.355em;
        margin-top: 3px;
    }

    .u6f3b7 {
        width: 0;
        margin-left: 1.07em;
        flex: auto;
    }

    .uccfc3 {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }

    .u582e0 {
        color: rgb(18, 144, 201);
        font-size: 1.14em;
    }

    .uc86b5 {
        color: rgb(132, 151, 171);
        font-size: 1.14em;
    }

    .u8ed36 {
        height: 100%;
        line-height: 1.5;
        color: rgb(26, 35, 50);
        font-size: 1.2857142857143rem;
        padding-top: 0.71em;
        padding-bottom: 2.85em;
    }

    .srccomponentstimeLineindexvuecssEnd {}
</style>